import React, { createContext, useContext, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { restoreSession, logoutUser } from '../store/authActions';
import { selectIsAuthenticated, selectUser, selectAuthLoading } from '../store/authSlice';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const user = useSelector(selectUser);
  const loading = useSelector(selectAuthLoading);

  useEffect(() => {
    // Restore session on app startup
    dispatch(restoreSession());
  }, [dispatch]);

  const login = (userData) => {
    // This is now handled by Redux actions
    // Kept for backward compatibility
    console.log('Login method called - handled by Redux');
  };

  const logout = () => {
    dispatch(logoutUser());
  };

  const value = {
    isAuthenticated,
    user,
    login,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};